import React from 'react';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';
import ProtectedEmail from '../components/ProtectedEmail';
import styles from '../styles/Privacidad.module.css';

const Privacidad = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`${styles.container} ${isDarkMode ? styles.dark : ''}`}>
      <main className={styles.main}>
        <div className={`${styles.contentContainer} ${isDarkMode ? styles.dark : ''}`}>
          <h1 className={styles.title}>Política de Privacidad - ExamenCAP</h1>
          
          <p className={styles.lastUpdated}>Última actualización: 26 de febrero de 2025</p>
          
          <section>
            <h2>1. Introducción</h2>
            <p>
              Bienvenido a ExamenCAP. Valoramos y respetamos su privacidad. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos su información cuando utiliza nuestra aplicación web progresiva (PWA).
            </p>
          </section>
          
          <section>
            <h2>2. Información que recopilamos</h2>
            
            <h3>2.1 Información técnica</h3>
            <ul>
              <li><strong>Huella digital del navegador</strong>: Generamos una huella digital única basada en características de su navegador y dispositivo (como resolución de pantalla, zona horaria, idioma, características de WebGL y Canvas) para identificar su sesión.</li>
              <li><strong>Información del dispositivo</strong>: Recopilamos información sobre su dispositivo, incluyendo tipo de navegador, sistema operativo y resolución de pantalla.</li>
              <li><strong>Datos de uso</strong>: Registramos información sobre cómo utiliza nuestra aplicación, incluyendo las pruebas realizadas y el progreso en los tests.</li>
            </ul>
            
            <h3>2.2 Información de registro</h3>
            <ul>
              <li>Si crea una cuenta o utiliza nuestro servicio de prueba gratuita, podemos recopilar información adicional como su ubicación geográfica general.</li>
            </ul>
          </section>
          
          <section>
            <h2>3. Cómo utilizamos su información</h2>
            <p>Utilizamos la información recopilada para:</p>
            <ul>
              <li>Proporcionar y mantener nuestro servicio</li>
              <li>Gestionar su cuenta y acceso a las pruebas</li>
              <li>Limitar el uso de pruebas gratuitas a un número razonable por usuario</li>
              <li>Mejorar y personalizar la experiencia del usuario</li>
              <li>Detectar y prevenir actividades fraudulentas</li>
            </ul>
          </section>
          
          <section>
            <h2>4. Almacenamiento de datos</h2>
            
            <h3>4.1 Almacenamiento local</h3>
            <ul>
              <li>Utilizamos el almacenamiento local de su navegador para guardar información como tokens de autenticación y estado de pruebas gratuitas.</li>
              <li>Esta información se almacena en su dispositivo y no se transmite a nuestros servidores excepto cuando es necesario para verificar su acceso.</li>
            </ul>
            
            <h3>4.2 Service Worker y caché</h3>
            <ul>
              <li>Nuestra aplicación utiliza Service Workers para funcionar sin conexión.</li>
              <li>Almacenamos en caché ciertos datos, incluidas preguntas de prueba y recursos estáticos, para mejorar el rendimiento y permitir el uso sin conexión.</li>
            </ul>
          </section>
          
          <section>
            <h2>5. Cookies y tecnologías similares</h2>
            <p>No utilizamos cookies tradicionales, pero empleamos:</p>
            <ul>
              <li><strong>Almacenamiento local del navegador</strong>: Para guardar sus preferencias y estado de sesión.</li>
              <li><strong>Huella digital del navegador</strong>: Como alternativa a las cookies para identificar sesiones y limitar el uso de pruebas gratuitas.</li>
            </ul>
          </section>
          
          <section>
            <h2>6. Base legal para el procesamiento</h2>
            <p>Procesamos sus datos personales basándonos en:</p>
            <ul>
              <li><strong>Ejecución de un contrato</strong>: Cuando utiliza nuestros servicios, aceptando nuestros Términos de Servicio.</li>
              <li><strong>Intereses legítimos</strong>: Para mejorar nuestros servicios, prevenir fraudes y garantizar la seguridad.</li>
              <li><strong>Consentimiento</strong>: Cuando nos proporciona información voluntariamente.</li>
            </ul>
          </section>
          
          <section>
            <h2>7. Sus derechos</h2>
            <p>Según las leyes de protección de datos aplicables, usted tiene derecho a:</p>
            <ul>
              <li>Acceder a sus datos personales</li>
              <li>Rectificar datos inexactos</li>
              <li>Solicitar la eliminación de sus datos</li>
              <li>Oponerse al procesamiento de sus datos</li>
              <li>Solicitar la portabilidad de sus datos</li>
              <li>Retirar su consentimiento en cualquier momento</li>
            </ul>
            <p>Para ejercer estos derechos, contáctenos a través de los medios proporcionados al final de esta política.</p>
          </section>
          
          <section>
            <h2>8. Retención de datos</h2>
            <p>Conservamos sus datos personales solo durante el tiempo necesario para los fines establecidos en esta política o según lo requiera la ley. Específicamente:</p>
            <ul>
              <li>Los datos de cuenta y perfil se conservan mientras mantenga su cuenta activa</li>
              <li>Los datos de uso se conservan por un período máximo de 12 meses</li>
              <li>Las huellas digitales del navegador se conservan por un máximo de 6 meses</li>
              <li>Los registros técnicos se conservan por un período de 3 meses</li>
            </ul>
            <p>Una vez que los datos ya no sean necesarios, serán eliminados o anonimizados de manera segura.</p>
            
            <h3>8.1 Almacenamiento en la nube</h3>
            <p>Algunos de sus datos pueden ser almacenados en servidores en la nube. En todos los casos, utilizamos exclusivamente proveedores de servicios con servidores ubicados en la Unión Europea, garantizando así el cumplimiento del Reglamento General de Protección de Datos (RGPD).</p>
            <p>Todos los datos almacenados en la nube están protegidos mediante técnicas de cifrado avanzadas, tanto en tránsito como en reposo, para garantizar su confidencialidad e integridad.</p>
          </section>
          
          <section>
            <h2>9. Transferencias internacionales de datos</h2>
            <p>No realizamos transferencias internacionales de sus datos personales fuera del Espacio Económico Europeo (EEE). Todos nuestros servidores y proveedores de servicios están ubicados dentro del EEE y cumplen con el RGPD.</p>
          </section>
          
          <section>
            <h2>10. Medidas de seguridad</h2>
            <p>Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales, incluyendo:</p>
            <ul>
              <li>Cifrado de datos en tránsito mediante protocolos SSL/TLS</li>
              <li>Cifrado de datos en reposo utilizando algoritmos de cifrado avanzados (AES-256)</li>
              <li>Acceso restringido a datos personales solo a personal autorizado</li>
              <li>Sistemas de detección de intrusiones y monitoreo de seguridad</li>
              <li>Copias de seguridad regulares y planes de recuperación ante desastres</li>
              <li>Evaluaciones periódicas de seguridad y pruebas de vulnerabilidad</li>
              <li>Servidores seguros ubicados exclusivamente en la Unión Europea</li>
              <li>Cumplimiento de estándares de seguridad internacionales</li>
            </ul>
            <p>Nos comprometemos a mantener la seguridad de sus datos como una prioridad absoluta y actualizamos regularmente nuestras medidas de seguridad para adaptarnos a las nuevas tecnologías y amenazas.</p>
          </section>
          
          <section>
            <h2>11. Procedimiento para ejercer sus derechos</h2>
            <p>Para ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, puede:</p>
            <ul>
              <li>Enviar un correo electrónico a <ProtectedEmail email="derechos@examencap.es" linkText="derechos@examencap.es" /> con el asunto "Ejercicio de Derechos RGPD"</li>
              <li>Enviar una solicitud por escrito a nuestra dirección postal indicada en la sección de contacto</li>
            </ul>
            <p>Su solicitud debe incluir su nombre completo, dirección de correo electrónico asociada a su cuenta, y una descripción clara del derecho que desea ejercer. Responderemos a su solicitud en un plazo máximo de un mes, que podrá prorrogarse dos meses más en casos de especial complejidad.</p>
            <p>Si considera que no hemos atendido adecuadamente su solicitud, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).</p>
          </section>
          
          <section>
            <h2>12. Cambios a esta política</h2>
            <p>Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos cualquier cambio significativo publicando la nueva política en nuestra aplicación con al menos 15 días de antelación a su entrada en vigor.</p>
          </section>
          
          <section id="contacto">
            <h2>13. Contacto</h2>
            <p>Si tiene preguntas sobre esta Política de Privacidad o sobre cómo tratamos sus datos personales, contáctenos en:</p>
            
            {/* Utilizamos técnicas para evitar que los motores de búsqueda indexen esta información */}
            <div className={styles.contactInfo} data-nosnippet>
              <div>
                <p>Responsable: Ramon Asen Pons Miralles</p>
                <p>DNI: 43208755N</p>
                <p>Email: <ProtectedEmail email="contacto@examencap.es" linkText="contacto@examencap.es" /></p>
              </div>
              <div>
                <p>Dirección: Calle Eusebio Estada 29, 8A</p>
                <p>Localidad: Palma de Mallorca</p>
                <p>Código Postal: 07004</p>
                <p>Provincia: Islas Baleares, España</p>
              </div>
            </div>
          </section>
          
          <div className={styles.disclaimer}>
            <p>Esta política está diseñada para cumplir con el Reglamento General de Protección de Datos (RGPD) de la UE y otras leyes de privacidad aplicables.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacidad;